import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "antd";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import TextInput from "../../components/inputs/TextInput";
import FormValidator from "../../infra/services/validations/FormValidator";
import BaseButton from "../../components/buttons/BaseButton";
import Logo from "../../assets/LOGO FINAL verde.png";
import {
  LoginContainer,
  LoginCard,
  LoginForm,
  LogoImg,
  LogoSection,
  LoginButtonDiv,
  BaseLink,
  TermsLink,
  TemporaryContainer,
  TemporaryText
} from "./LoginPageStyles";
import { Icon } from "antd";
import { Login } from "../../infra/requests/AuthRequests";
import { GetWedding } from "../../infra/requests/MyWeddingRequests";
import { SaveUser } from "../../redux/User/user.actions";
import { SaveWedding, SaveContactConfirmation } from "../../redux/Wedding/wedding.actions";
import { CheckContactConfirmation } from "../../infra/requests/ContactConfirmationRequests";
import { auth_token_key } from "../../infra/config/LocalStorageKeys";
import { withLocalize } from "react-localize-redux";
import TermsModal from "../../components/modals/TermsModal";
import PasswordWarningModal from "../../components/modals/PasswordWarningModal";
import Alert from "../../components/alert/Alert";
import { accessReserve } from "../../infra/services/utils/Helpers";

const formRules = FormValidator.make({
  email: "required|email",
  password: "required|min:6"
});


/**
 * Destino a abrir depois do login, vindo de `?redirect=`.
 *
 * Só se aceitam caminhos internos: um URL absoluto ou `//host` permitiria
 * usar o login para reencaminhar para fora da plataforma.
 */
const getSafeRedirect = search => {
  try {
    const value = new URLSearchParams(search || "").get("redirect");
    if (!value) return null;
    if (!value.startsWith("/") || value.startsWith("//")) return null;
    return value;
  } catch {
    return null;
  }
};

class LoginPage extends Component {
  state = {
    openTerms: false,
    passwordWarningModal: false,
    passwordModalText: undefined,
    passwordModalTitle: undefined,
    showPassword: false
  };

  onSubmit = async values => {
    const { translate } = this.props;

    try {
      const { SaveUser, SaveWedding, SaveContactConfirmation, history } = this.props;
      const result = await Login(values);

      if (result?.success) {
        localStorage.setItem(auth_token_key, result.data.token);
        SaveUser(result.data.user);

        const wedding = await GetWedding();
        if (wedding.success) {
          SaveWedding(wedding.data);
        }

        const contactConfirmation = await CheckContactConfirmation();
        if (contactConfirmation?.data) {
          SaveContactConfirmation(contactConfirmation.data);
        }

        // Quem chegou aqui a partir de um link (ex.: agenda partilhada)
        // volta ao destino em vez de cair no início
        const redirect = getSafeRedirect(this.props.location?.search);
        if (redirect) {
          history.push(redirect);
        } else if (accessReserve(result?.data?.user, wedding)) {
          history.push('/home');
        } else history.push("/");
      }
      else {
        //Special Case - show a modal so we make sure the user sees the message
        if (result?.message === 'MUST_DEFINE_PASSWORD') {
          this.setState({
            passwordWarningModal: true,
            passwordModalText: 'ALERT_DEFINE_PASSWORD',
            passwordModalTitle: `${translate('ALERT_ATTENTION_TEXT')} - ${translate('EMAIL_SUBJECT_COMPLETE_REGISTRATION')}`
          });
        }
        else {
          Alert.new({
            type: "error",
            title: translate('ALERT_ERROR_TITLE'),
            text: translate(result.message)
          });
        }
      }
    }
    catch (e) {
      console.error(e);
    }
  };

  componentDidMount = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

  render() {
    const { handleSubmit, submitting, translate } = this.props;
    const { openTerms, showPassword, passwordWarningModal, passwordModalText, passwordModalTitle } = this.state;

    return (
      <LoginContainer>
        <LoginForm onSubmit={handleSubmit(this.onSubmit)}>
          <LoginCard>
            <LogoSection>
              <LogoImg src={Logo} alt="logo" />
            </LogoSection>
            <Field
              component={TextInput}
              name="email"
              type="email"
              label={translate("EMAIL")}
            />
            <Field
              component={TextInput}
              name="password"
              type={showPassword ? 'text' : 'password'}
              label={translate("PASSWORD")}
              suffix={<Icon type={showPassword ? 'eye-invisible' : 'eye'} onClick={() => this.setState({ showPassword: !showPassword })} />}
            />
            <Row>
              <Col xs={12}>
                <TermsLink onClick={() => this.setState({ openTerms: true })}>
                  {translate("SEE_TERMS_BUTTON")}
                </TermsLink>
              </Col>
              <Col xs={12}>
                <BaseLink to="/recover-account">
                  {translate("FORGOT_PASSWORD")}
                </BaseLink>
              </Col>
            </Row>
            <Row>
              <Col xs={24} style={{display: 'flex', flexDirection: 'row-reverse'}}>
                <BaseLink to="/login-guest">
                  {translate("SIGN_IN_GUEST")}
                </BaseLink>
              </Col>
            </Row>
            {/* <TemporaryContainer>
              <TemporaryText>
                {translate("LOGIN_CONSTRUCTION_MESSAGE")}
                <div>{translate("THE_TEAM_TAG")}</div>
              </TemporaryText>
            </TemporaryContainer> */}
            <LoginButtonDiv>
              <BaseButton
                align="initial"
                variant="raised"
                htmlType="submit"
                type="primaryLarge"
                loading={submitting}
                bgColor={'primaryColor'}
                text={translate("LOGIN_WD")}
              />
            </LoginButtonDiv>
          </LoginCard>
        </LoginForm>
        <TermsModal
          open={openTerms}
          onClose={() => this.setState({ openTerms: false })}
        />
        <PasswordWarningModal
          passwordModalTitle={passwordModalTitle}
          passwordModalText={passwordModalText}
          open={passwordWarningModal}
          onClose={() => this.setState({ passwordWarningModal: false })}
        />
      </LoginContainer>
    );
  }
}

LoginPage = reduxForm({
  form: "login",
  validate: formRules
})(LoginPage);

const mapStateToProps = (state, ownProps) => ({});

const mapActionToProps = dispatch => bindActionCreators({ SaveUser, SaveWedding, SaveContactConfirmation }, dispatch);

export default withLocalize(
  connect(mapStateToProps, mapActionToProps)(LoginPage)
);
